import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Transporters from "@/pages/Transporters";
import Dispatches from "@/pages/Dispatches";
import NewDispatch from "@/pages/NewDispatch";
import DispatchDetail from "@/pages/DispatchDetail";
import Communications from "@/pages/Communications";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Queries from "@/pages/Queries";
import PODCenter from "@/pages/PODCenter";
import DispatchImport from "@/pages/DispatchImport";
import OverdueDispatches from "@/pages/OverdueDispatches";
import AuditLogs from "@/pages/AuditLogs";
import TrackPublic from "@/pages/TrackPublic";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/track/:token" element={<TrackPublic />} />

            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="/dispatches" element={<Dispatches />} />
              <Route path="/dispatches/new" element={<NewDispatch />} />
              <Route path="/dispatches/:id" element={<DispatchDetail />} />
              <Route path="/overdue" element={<OverdueDispatches />} />
              <Route path="/pod" element={<PODCenter />} />
              <Route path="/queries" element={<Queries />} />
              <Route path="/import" element={<DispatchImport />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/transporters" element={<Transporters />} />
              <Route path="/communications" element={<Communications />} />
              <Route path="/users" element={<Users />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/audit" element={<AuditLogs />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
